import React from "react";

const Unauthorized: React.FC = () => {
    return (
        <h2 style={{ color: 'red', textAlign: 'center', fontWeight: 'bold' }}>Unauthorized!</h2>
    )
}

export default Unauthorized;